import React from 'react'

const styles = {
    position: 'fixed',
    top: "30%",
    right: 0


}
const Herramientas = ({ colors, activeColor, setcolor, setCleaning, setPlaying }) => {
    return (
        <div className="herramientas" style={styles}>
            <ul className="nav flex-column">
                {colors.map(Color =>
     
                    <span key = {Color.id} 
                        
                        className={`nav-link fs-1 helper ${activeColor === Color.cod? "border":null}`}
                        aria-current="page"
                        onClick={() => setcolor(Color.cod)}
                         style={{ color: `${Color.cod}` }}>
                        <i className="bi bi-pencil-fill"></i>
                    </span>
                )}

                <span className={`nav-link fs-1 helper ${activeColor === 'eraser' ? "border":null}`}
                    aria-current="page"
              
                    onClick={() => setCleaning('eraser')}

                    style={{ color: "white" }}>
                    <i className="bi bi-eraser-fill"></i>
                </span>
                <span className='nav-link fs-1 helper'
                    onClick={() => setPlaying(false)}
                    aria-current="page"
                    style={{ color: "white" }}
                >
                    <i className="bi bi-x-circle"></i>
                </span>

            </ul>
        </div>
    )
}

export default Herramientas
